<template>
  <span class="icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24">
      <mask
        id="mask0_2276_57"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect
          width="24"
          height="24"
          fill="white"/>
      </mask>
      <g mask="url(#mask0_2276_57)">
        <path
          d="M5.06934 18.7094C5.58667 19.0321 6.44667 19.3908 7.356 19.3908C8.184 19.3908 8.95334 19.1507 9.59067 18.7414C9.59067 18.7414 9.592 18.7414 9.59334 18.7401L12 17.2361V22.6667C11.6187 22.6667 11.2347 22.5628 10.9013 22.3548L5.06934 18.7094Z"
          fill="#225086"/>
        <path
          d="M10.4707 2.00937L0.470662 13.2894C-0.301338 14.1614 -0.100005 15.4787 0.901328 16.104C0.901328 16.104 4.60266 18.4174 5.06933 18.7094C5.58666 19.032 6.44666 19.3907 7.35599 19.3907C8.18399 19.3907 8.95333 19.1507 9.59066 18.7414C9.59066 18.7414 9.59199 18.7414 9.59333 18.74L12 17.236L6.18133 13.5987L12.0013 7.03337V1.33337C11.436 1.33337 10.8707 1.55871 10.4707 2.00937Z"
          fill="#66DDFF"/>
        <path
          d="M6.18127 13.5987L6.25061 13.6413L11.9999 17.236H12.0013V7.03466L11.9999 7.03333L6.18127 13.5987Z"
          fill="#CBF8FF"/>
        <path
          d="M23.0987 16.104C24.1 15.4787 24.3013 14.1613 23.5293 13.2893L16.968 5.888C16.4387 5.64133 15.8453 5.5 15.2173 5.5C13.984 5.5 12.8813 6.032 12.148 6.868L12.0027 7.032L17.8213 13.5973L12.0013 17.2347V22.6653C12.384 22.6653 12.7653 22.5613 13.0987 22.3533L23.0987 16.1027V16.104Z"
          fill="#074793"/>
        <path
          d="M12.0013 1.33337V7.03337L12.1467 6.86937C12.88 6.03337 13.9827 5.50137 15.216 5.50137C15.8453 5.50137 16.4373 5.64404 16.9667 5.88937L13.528 2.01071C13.1293 1.56004 12.564 1.33471 12 1.33471L12.0013 1.33337Z"
          fill="#0294E4"/>
        <path
          d="M17.82 13.5987L12.0013 7.03467V17.2347L17.82 13.5987Z"
          fill="#96BCC2"/>
      </g>
    </svg>

  </span>
</template>

<style lang="scss" scoped>
  .icon {
    display: inline-block;

    svg {
      display: block;
      width: 1em;
      height: 1em;
    }
  }
</style>
